import React from "react";
import Reveal from "./Reveal";
import { MapPin, Phone, Clock, Star } from "lucide-react";

const locations = [
  {
    id: "cestlice",
    name: "CarSpa Čestlice",
    address: "Pražská 138, Aquapalace Čestlice",
    phone: "730 595 595",
    phoneHref: "+420730595595",
    hours: "Po–Pá 8:00 – 19:00",
    photo:
      "https://images.pexels.com/photos/14231701/pexels-photo-14231701.jpeg?auto=compress&cs=tinysrgb&w=1400&q=80",
    photoAlt: "Leštění laku v CarSpa Čestlice",
    rating: "4,9",
    googleUrl: "https://share.google/ONJ5HdrUwfzRJLKqG",
  },
  {
    id: "butovice",
    name: "CarSpa Nové Butovice",
    address: "Coral Office Park, Nové Butovice",
    phone: "732 327 777",
    phoneHref: "+420732327777",
    hours: "Po–Pá 8:00 – 19:00",
    photo:
      "https://images.pexels.com/photos/6873174/pexels-photo-6873174.jpeg?auto=compress&cs=tinysrgb&w=1400&q=80",
    photoAlt: "Detailing Mercedesu v CarSpa Nové Butovice",
    rating: "4,9",
    googleUrl:
      "https://www.google.com/maps/search/?api=1&query=Car+SPA+Nov%C3%A9+Butovice+Coral+Office+Park",
  },
];

export const Locations = () => {
  return (
    <section id="pobocky" data-testid="locations-section" className="relative py-20 sm:py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <Reveal className="max-w-3xl mb-12 md:mb-16">
          <div className="text-[10px] sm:text-[11px] tracking-[0.35em] sm:tracking-[0.4em] uppercase text-[#D4AF37] mb-5 md:mb-6">
            05 — Naše pobočky
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.05]">
            Dvě adresy.
            <br />
            <span className="italic text-gold-gradient">Jedna úroveň péče.</span>
          </h2>
          <p className="mt-5 md:mt-6 text-sm sm:text-base text-zinc-400 font-light max-w-xl leading-relaxed">
            Voucher uplatníte ve kterékoli z našich poboček v Praze. Expanze pokračuje —
            brzy přibudou další lokality.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6 lg:gap-8">
          {locations.map((loc, i) => (
            <Reveal key={loc.id} delay={i * 150}>
              <div
                data-testid={`location-card-${loc.id}`}
                className="gold-border overflow-hidden flex flex-col h-full group"
              >
                <div className="aspect-[16/10] overflow-hidden bg-black relative">
                  <img
                    src={loc.photo}
                    alt={loc.photoAlt}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-105 group-hover:scale-100"
                    loading="lazy"
                    data-testid={`location-photo-${loc.id}`}
                  />
                </div>

                <div className="p-6 sm:p-8 md:p-10 flex flex-col flex-1">
                  <div className="text-[10px] tracking-[0.3em] sm:tracking-[0.35em] uppercase text-[#D4AF37] mb-2">
                    Pobočka
                  </div>
                  <h3 className="font-display text-2xl sm:text-3xl text-white mb-5 md:mb-6">{loc.name}</h3>

                  <ul className="space-y-3.5 md:space-y-4 text-sm text-zinc-300 mb-6 md:mb-8">
                    <li className="flex gap-4">
                      <MapPin size={18} className="text-[#D4AF37] mt-[2px] shrink-0" strokeWidth={1} />
                      <span className="font-light leading-relaxed">{loc.address}</span>
                    </li>
                    <li className="flex gap-4">
                      <Phone size={18} className="text-[#D4AF37] mt-[2px] shrink-0" strokeWidth={1} />
                      <a href={`tel:${loc.phoneHref}`} className="lux-link hover:text-[#D4AF37] transition-colors">
                        {loc.phone}
                      </a>
                    </li>
                    <li className="flex gap-4">
                      <Clock size={18} className="text-[#D4AF37] mt-[2px] shrink-0" strokeWidth={1} />
                      <span className="font-light">{loc.hours}</span>
                    </li>
                  </ul>

                  {loc.rating && (
                    <div className="mt-auto pt-4 border-t border-white/5">
                      <div
                        data-testid={`location-google-${loc.id}`}
                        className="flex items-center flex-wrap gap-x-3 gap-y-1 border border-[#D4AF37]/40 px-3.5 sm:px-4 py-3"
                      >
                        <div className="relative inline-flex" aria-label={`Hodnocení ${loc.rating} z 5`}>
                          <div className="flex gap-0.5 text-[#D4AF37]/30">
                            {[...Array(5)].map((_, s) => (
                              <Star key={s} size={16} fill="currentColor" strokeWidth={0} />
                            ))}
                          </div>
                          <div
                            className="absolute inset-0 flex gap-0.5 text-[#D4AF37] overflow-hidden"
                            style={{ width: `${(parseFloat(loc.rating.replace(",", ".")) / 5) * 100}%` }}
                          >
                            {[...Array(5)].map((_, s) => (
                              <Star key={s} size={16} fill="currentColor" strokeWidth={0} className="shrink-0" />
                            ))}
                          </div>
                        </div>
                        <span className="font-display text-lg text-white leading-none">
                          {loc.rating}
                        </span>
                        <span className="text-[10px] sm:text-[11px] tracking-[0.2em] sm:tracking-[0.25em] uppercase text-zinc-300">
                          Recenze Google
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Locations;
